/**
 * Checkout Tracker для Google Analytics Enhanced Ecommerce
 * Відстежує початок оформлення замовлення та відправляє подію begin_checkout
 */
class CheckoutTracker {
    constructor() {
        // Синглтон - если уже есть экземпляр, возвращаем его
        if (CheckoutTracker.instance) {
            return CheckoutTracker.instance;
        }
        this.trackedCheckouts = new Set(); // Для запобігання дублюванню
        this.lastSentAt = 0; // Час останньої відправки
        this.isProcessing = false; // Флаг для предотвращения одновременных вызовов
        this.init();
        // Сохраняем экземпляр
        CheckoutTracker.instance = this;
    }
    init() {
        // Ініціалізуємо слухачі подій
        this.setupCheckoutHandlers();
        // Додаємо слухачі для відстеження змін кількості
        this.setupQuantityChangeHandlers();
    }
    /**
     * Налаштовує обробники для відстеження початку замовлення
     */
    setupCheckoutHandlers() {
        // Слухаємо кліки на кнопки оформлення замовлення
        document.addEventListener('click', (event) => {
            this.handleClick(event);
        }, true);
    }
    /**
     * Налаштовує обробники для відстеження змін кількості товарів
     */
    setupQuantityChangeHandlers() {
        // Слухаємо зміни в input полях кількості
        document.addEventListener('input', (event) => {
            this.handleQuantityChange(event);
        }, true);
        // Слухаємо кліки на кнопки +/-
        document.addEventListener('click', (event) => {
            this.handleQuantityButtonClick(event);
        }, true);
        // Слухаємо кастомні події додавання товарів
        document.addEventListener('productAddedToBasket', () => {
            this.updateBasketCache();
        });
        // Слухаємо зміни в DOM (додавання/видалення товарів)
        this.setupDOMObserver();
    }
    /**
     * Обробляє зміни в input полях кількості
     * @param {Event} event - Подія input
     */
    handleQuantityChange(event) {
        const target = event.target;
        // Перевіряємо, чи це input кількості в кошику
        if (target.type === 'number' && 
            target.closest('.product__amount-wrapper') &&
            target.closest('.product')) {
            // Оновлюємо кеш товарів при зміні кількості
            this.updateBasketCache();
        }
    }
    /**
     * Обробляє кліки на кнопки +/-
     * @param {Event} event - Подія кліку
     */
    handleQuantityButtonClick(event) {
        const target = event.target;
        // Перевіряємо, чи це кнопка + або - в кошику
        if (target.closest('.product__amount-wrapper') &&
            target.closest('.product') &&
            (target.textContent === '+' || target.textContent === '-')) {
            // Невелика затримка, щоб дати час Vue оновити DOM
            setTimeout(() => {
                this.updateBasketCache();
            }, 100);
        }
    }
    /**
     * Оновлює кеш товарів кошика
     */
    updateBasketCache() {
        // Очищуємо кеш відстежених checkout'ів, щоб дозволити повторне відстеження
        this.trackedCheckouts.clear();
    }
    /**
     * Принудительно обновляет данные перед begin_checkout
     */
    forceUpdateBasketData() {
        // Очищаем кеш
        this.updateBasketCache();
        // Небольшая задержка для обновления DOM
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve();
            }, 50);
        });
    }
    /**
     * Налаштовує MutationObserver для відстеження змін в DOM
     */
    setupDOMObserver() {
        // Спостерігаємо за змінами в кошику
        const basketContainer = document.querySelector('.basket__products') || 
                               document.querySelector('.ordering') ||
                               document.querySelector('.basket');
        if (basketContainer) {
            const observer = new MutationObserver((mutations) => {
                let shouldUpdate = false;
                mutations.forEach((mutation) => {
                    if (mutation.type === 'childList') {
                        // Перевіряємо, чи додалися або видалилися товари
                        if (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0) {
                            shouldUpdate = true;
                        }
                    }
                });
                if (shouldUpdate) {
                    this.updateBasketCache();
                }
            });
            observer.observe(basketContainer, {
                childList: true,
                subtree: true
            });
            // Зберігаємо посилання на observer для очищення
            this.domObserver = observer;
        }
    }
    /**
     * Налаштовує MutationObserver для відстеження змін в DOM
     */
    setupMutationObserver() {
        // MutationObserver отключен - не нужен для checkout трекера
            return;
    }
    /**
     * Обробляє кліки на сторінці
     * @param {Event} event - Подія кліку
     */
    handleClick(event) {
        const target = event.target;
        // Перевіряємо глобальний флаг - якщо ручний виклик вже спрацював, пропускаємо
        if (window.checkoutManualTriggered) {
            return;
        }
        // Перевіряємо, чи ми на ordering сторінці - там не відстежуємо автоматично
        if (document.querySelector('.ordering') || document.querySelector('.ordering__wrapper')) {
            return;
        }
        // Перевіряємо, чи це кнопка оформлення замовлення
        if (this.isCheckoutButton(target)) {
            // Перевіряємо, чи це кнопка переходу до кошика (не повинна спрацьовувати)
            const isBasketButton = target.closest('.basket__buttons-button') ||
                                 target.closest('[data-basket-button]') ||
                                 target.hasAttribute('data-basket-button');
        if (isBasketButton) {
        // Перевіряємо, чи це кнопка "Оформити замовлення" в кошику
        const buttonText = target.textContent || target.innerText || '';
        const isCheckoutButton = buttonText.toLowerCase().includes('оформити') || 
                               buttonText.toLowerCase().includes('замовлення') ||
                               buttonText.toLowerCase().includes('processorder') ||
                               buttonText.toLowerCase().includes('оформить') ||
                               target.closest('[data-checkout-button]') ||
                               target.hasAttribute('data-checkout-button');
        if (isCheckoutButton) {
            // НЕ викликаємо автоматичний трекер для кнопок в кошику - покладаємося на ручний виклик
            return;
        }
            return;
        }
            // Добавляем небольшую задержку для предотвращения множественных кликов
            setTimeout(() => {
                this.trackBeginCheckout();
            }, 100);
        }
    }
    /**
     * Перевіряє, чи є елемент кнопкою оформлення замовлення
     * @param {Element} element - Елемент для перевірки
     * @returns {boolean}
     */
    isCheckoutButton(element) {
        // Перевіряємо по тексту кнопки
        const buttonText = element.textContent || element.innerText || '';
        const checkoutTexts = [
            'Оформити замовлення',
            'Підтвердити замовлення',
            'Оформити',
            'Замовити',
            'Підтвердити',
            'Submit Order',
            'Place Order',
            'Checkout',
            'Оплатити'
        ];
        if (checkoutTexts.some(text => buttonText.toLowerCase().includes(text.toLowerCase()))) {
            return true;
        }
        // Перевіряємо по класах та селекторах
        const classList = element.classList;
        // Кнопка в корзине
        if (classList.contains('main-button') &&
            element.closest('.basket__buttons-button')) {
                return true;
            }
        // Інші можливі селектори
        if (classList.contains('main-button') &&
            (element.closest('.checkout-button') ||
                element.closest('.order-button'))) {
            return true;
        }
        // Перевіряємо по data-атрибутах
        if (element.hasAttribute('data-checkout') ||
            element.hasAttribute('data-order') ||
            element.hasAttribute('data-checkout-button')) {
            return true;
        }
        return false;
    }
    /**
     * Відстежує початок оформлення замовлення з переданим store
     * @param {Array|null} items
     * @param {boolean} force - Примусово відправити, ігноруючи захист від дублювання
     * @param {Object} store - Vuex store
     */
    async trackBeginCheckoutWithStore(items = null, force = false, store = null) {
        // Запобігаємо одночасним викликам
        if (this.isProcessing && !force) {
            return;
        }
        // Запобігаємо дублюванню: не частіше ніж раз на 3 секунди (зменшено з 5)
        const now = Date.now();
        if (!force && now - this.lastSentAt < 3000) {
            return;
        }
        this.isProcessing = true;
        // ПРИНУДИТЕЛЬНО обновляем данные перед begin_checkout
        await this.forceUpdateBasketData();
        
        let basketItems = items;
        if (!basketItems || !Array.isArray(basketItems) || basketItems.length === 0) {
            // Отримуємо дані товарів з кошика, якщо не передані
            basketItems = this.getBasketItemsWithStore(store);
        }
        if (!basketItems || basketItems.length === 0) {
            this.isProcessing = false;
            return;
        }
        // removed debug logging per requirements
        // Створюємо унікальний ключ для цього checkout (більш детальний)
        const itemsSignature = basketItems.map(item => `${item.item_id}_${item.quantity}_${item.price}`).join('|');
        const checkoutKey = `checkout_${basketItems.length}_${itemsSignature}`;
        // Перевіряємо, чи не відстежували вже цей checkout (тільки якщо не force)
        if (!force && this.trackedCheckouts.has(checkoutKey)) {
            this.isProcessing = false;
            return;
        }
        // Відправляємо подію
        this.sendBeginCheckoutEvent(basketItems);
        // Позначаємо як відстежений
        this.trackedCheckouts.add(checkoutKey);
        this.lastSentAt = now;
        // Очищаем старые записи (оставляем только последние 10)
        if (this.trackedCheckouts.size > 10) {
            const keysArray = Array.from(this.trackedCheckouts);
            const keysToDelete = keysArray.slice(0, keysArray.length - 10);
            keysToDelete.forEach(key => this.trackedCheckouts.delete(key));
        }
        // Сбрасываем флаг обработки
        this.isProcessing = false;
    }
    /**
     * Відстежує початок оформлення замовлення (з переданими товарами або визначає їх сам)
     * @param {Array|null} items
     * @param {boolean} force - Примусово відправити, ігноруючи захист від дублювання
     */
    async trackBeginCheckout(items = null, force = false) {
        // Запобігаємо одночасним викликам
        if (this.isProcessing && !force) {
            return;
        }
        // Запобігаємо дублюванню: не частіше ніж раз на 3 секунди (зменшено з 5)
        const now = Date.now();
        if (!force && now - this.lastSentAt < 3000) {
            return;
        }
        this.isProcessing = true;
        // ПРИНУДИТЕЛЬНО обновляем данные перед begin_checkout
        await this.forceUpdateBasketData();
        let basketItems = items;
        if (!basketItems || !Array.isArray(basketItems) || basketItems.length === 0) {
            // Отримуємо дані товарів з кошика, якщо не передані
            basketItems = this.getBasketItems();
        }
        if (!basketItems || basketItems.length === 0) {
            this.isProcessing = false;
            return;
        }
        // removed debug logging per requirements
        // Створюємо унікальний ключ для цього checkout (більш детальний)
        const itemsSignature = basketItems.map(item => `${item.item_id}_${item.quantity}_${item.price}`).join('|');
        const checkoutKey = `checkout_${basketItems.length}_${itemsSignature}`;
        // Перевіряємо, чи не відстежували вже цей checkout (тільки якщо не force)
        if (!force && this.trackedCheckouts.has(checkoutKey)) {
            this.isProcessing = false;
            return;
        }
        // Відправляємо подію
        this.sendBeginCheckoutEvent(basketItems);
        // Позначаємо як відстежений
        this.trackedCheckouts.add(checkoutKey);
        this.lastSentAt = now;
        // Очищаем старые записи (оставляем только последние 10)
        if (this.trackedCheckouts.size > 10) {
            const keysArray = Array.from(this.trackedCheckouts);
            const keysToDelete = keysArray.slice(0, keysArray.length - 10);
            keysToDelete.forEach(key => this.trackedCheckouts.delete(key));
        }
        // Сбрасываем флаг обработки
        this.isProcessing = false;
    }
    /**
     * Отримує дані товарів з кошика
     * @returns {Array} Масив товарів
     */
    getBasketItems() {
        // ПРИНУДИТЕЛЬНО используем ТОЛЬКО catalog/currentProduct (как productViewTracker)
        if (window.Vue && window.Vue.prototype.$store) {
            const store = window.Vue.prototype.$store;
            // ПРИНУДИТЕЛЬНО получаем текущий товар из catalog (ТОЧНО КАК В productViewTracker.js)
            const currentProduct = store.getters['catalog/currentProduct'];
            const productId = currentProduct ? this.extractProductId(currentProduct) : null;
            if (currentProduct && productId && currentProduct.title) {
                const formattedProduct = this.formatRawProductData(currentProduct);
                if (formattedProduct) {
                    const analyticsProduct = this.formatForAnalytics(formattedProduct, 1);
                    return [analyticsProduct];
                }
            } else {
                // Если currentProduct не найден, НЕ используем корзину - возвращаем пустой массив
                return [];
            }
        }
        return [];
    }
    /**
     * Отримує дані товарів з переданим store
     * @param {Object} store - Vuex store
     * @returns {Array} Масив товарів
     */
    getBasketItemsWithStore(store) {
        if (store) {
            // Проверяем, какие геттеры доступны в store
            const currentProduct = store.getters['catalog/currentProduct'];
            const basket = store.getters['basket/basket'];
            const secondBasket = store.getters['basket/secondBasket'];
            // ПРИОРИТЕТ 1: Проверяем корзину (все товары)
            if (basket && Array.isArray(basket) && basket.length > 0) {
                return this.formatBasketItemsFromStore(basket);
            } else if (secondBasket && Array.isArray(secondBasket) && secondBasket.length > 0) {
                return this.formatBasketItemsFromStore(secondBasket);
            }
            // ПРИОРИТЕТ 2: Если корзина пустая, используем текущий товар
            const productId = currentProduct ? this.extractProductId(currentProduct) : null;
            if (currentProduct && productId && currentProduct.title) {
                const formattedProduct = this.formatRawProductData(currentProduct);
                if (formattedProduct) {
                    const analyticsProduct = this.formatForAnalytics(formattedProduct, 1);
                    return [analyticsProduct];
                }
            } else {
                const windowProductId = window.currentProduct ? this.extractProductId(window.currentProduct) : null;
                if (window.currentProduct && windowProductId && window.currentProduct.title) {
                    const formattedProduct = this.formatRawProductData(window.currentProduct);
                    if (formattedProduct) {
                        const analyticsProduct = this.formatForAnalytics(formattedProduct, 1);
                        return [analyticsProduct];
                    }
                }
                // Если ни один источник не найден, возвращаем пустой массив
                return [];
            }
        }
        return [];
    }
    /**
     * Форматує сирі дані товару з store/глобальних змінних (ідентично productViewTracker.js)
     * @param {Object} product - Дані товару з store
     * @returns {Object}
     */
    formatRawProductData(product) {
        // Перевіряємо, чи це валідний об'єкт товару
        if (!product || typeof product !== 'object') {
            return null;
        }
        // Формуємо об'єкт з правильною структурою
        const productId = this.extractProductId(product);
        const normalizedId = this.normalizeId(productId);
        const formattedProduct = {
            id: normalizedId ?? productId,
            product_price_id: product.product_price_id || null, // Зберігаємо product_price_id якщо є
            title: product.title || '',
            productPrice: product.productPrice || {
                price: {price: 0},
                baseUnit: {isM2: false, title: 'шт'}
            },
            category: product.category || {name: '', title: ''},
            productBrand: product.productBrand || {title: ''}
        };
        // Додаткова перевірка ціни
        if (formattedProduct.productPrice && !formattedProduct.productPrice.price) {
            formattedProduct.productPrice.price = {price: 0};
        }
        if (formattedProduct.productPrice && !formattedProduct.productPrice.baseUnit) {
            formattedProduct.productPrice.baseUnit = {isM2: false, title: 'шт'};
        }
        return formattedProduct;
    }
    /**
     * Форматує дані товару для Google Analytics (ідентично productClickTracker.js)
     * @param {Object} productData - Дані товару
     * @param {number} quantity - Кількість товару
     * @returns {Object}
     */
    formatForAnalytics(productData, quantity = 1, element = null) {
        const price = this.extractPrice(productData, element);
        // Категорія фолбек: остання зі списку, якщо доступна
        let categoryOverride = '';
        try {
            if (typeof window !== 'undefined' && window.sessionStorage) {
                categoryOverride = sessionStorage.getItem('ga_last_item_category') || '';
            }
        } catch (e) { /* no-op */ }
        // Визначаємо назву товару - обов'язково має бути назва, а не ID
        const productId = this.extractProductId(productData);
        let itemName = productData.title || productData.name || '';
        if (!itemName) {
            itemName = `Товар ${productId || 'невідомий'}`;
        }
        // Додаткова перевірка: якщо назва дорівнює ID, шукаємо справжню назву
        if (itemName === productId?.toString() || itemName === productId) {
            // Спробуємо знайти назву в інших місцях
            const alternativeName = productData.product?.title || 
                                  productData.select_type?.title ||
                                  productData.product?.name ||
                                  productData.select_type?.name;
            if (alternativeName && alternativeName !== productId?.toString()) {
                itemName = alternativeName;
            }
        }
        // Визначаємо ID товару (ідентично productViewTracker.js - строка 967)
        const itemId = this.normalizeId(productId);
        // Визначаємо бренд з пріоритетом (ідентично productViewTracker.js):
        // 1. З даних товару (productBrand.title)
        // 2. З заголовка товару (евристика) - ОБОВ'ЯЗКОВО
        // 3. Фолбек
        let finalBrand = productData.productBrand?.title || '';
        // ЗАВЖДИ намагаємося витягнути бренд з заголовка, навіть якщо є productBrand
        if (itemName) {
            const extractedBrand = this.extractBrandFromTitle(itemName);
            // Якщо витягли бренд з заголовка, використовуємо його
            if (extractedBrand && extractedBrand.trim()) {
                finalBrand = extractedBrand;
            }
        }
        if (!finalBrand || !finalBrand.trim()) {
            finalBrand = 'Невизначений бренд';
        }
        // Визначаємо категорію з пріоритетом:
        // 1. З даних товару (category.name або category.title)
        // 2. Збережена в sessionStorage (з попереднього кліку)
        // 3. Фолбек
        let finalCategory = '';
        
        // Спочатку спробуємо отримати з даних товару
        if (productData.category) {
            finalCategory = productData.category.name || productData.category.title || '';
        }
        
        // Якщо не знайшли в даних товару, спробуємо sessionStorage
        if (!finalCategory) {
            try {
                if (typeof window !== 'undefined' && window.sessionStorage) {
                    finalCategory = sessionStorage.getItem('ga_last_item_category') || '';
                }
            } catch (e) { /* no-op */ }
        }
        
        if (!finalCategory) {
            finalCategory = 'Невизначена категорія';
        }
        
        const result = {
            item_name: itemName,
            item_id: itemId,
            price: price,
            currency: 'UAH',
            item_brand: finalBrand || '',
            item_category: finalCategory,
            quantity: parseInt(quantity || 1)
        };
        return result;
    }
    /**
     * Витягує ціну з даних товару
     * @param {Object} productData - Дані товару
     * @returns {number}
     */
    extractPrice(productData, element = null) {
        // ПРИОРИТЕТ 1: Ищем цену за единицу в данных товара (из store)
        if (productData.productPrice && productData.productPrice.price && productData.productPrice.price.price) {
            const price = parseFloat(productData.productPrice.price.price);
            if (!isNaN(price) && price > 0) {
                return price;
            }
        }
        
        // ПРИОРИТЕТ 1.1: Проверяем сохраненную цену за м² (для товаров с расчетом по площади)
        try {
            if (typeof window !== 'undefined' && window.sessionStorage) {
                const savedM2Price = sessionStorage.getItem('ga_m2_price');
                if (savedM2Price) {
                    const price = parseFloat(savedM2Price);
                    if (!isNaN(price) && price > 0) {
                        return price;
                    }
                }
            }
        } catch (e) {
            // Игнорируем ошибки sessionStorage
        }
        
        // ПРИОРИТЕТ 2: Ищем цену в других местах структуры данных
        if (productData.price) {
            const price = parseFloat(productData.price);
            if (!isNaN(price) && price > 0) {
                return price;
            }
        }
        
        if (productData.select_type && productData.select_type.price) {
            const price = parseFloat(productData.select_type.price);
            if (!isNaN(price) && price > 0) {
                return price;
            }
        }
        
        // ПРИОРИТЕТ 3: Если передан конкретный элемент, ищем цену в нем
        if (element) {
            const priceSelectors = [
                '.product__price h5', // ПРИОРИТЕТ 1: цена за единицу товара в h5
                '.product__price', // ПРИОРИТЕТ 2: цена за единицу товара (fallback)
                '.product-price', // ПРИОРИТЕТ 3: цена товара
                '.price', // ПРИОРИТЕТ 4: общий селектор цены
                '[data-price]', // ПРИОРИТЕТ 5: data-атрибут
                '.cost, .amount' // ПРИОРИТЕТ 6: альтернативные селекторы
            ];
            
            for (const selector of priceSelectors) {
                const priceElement = element.querySelector(selector);
                if (priceElement) {
                    // Сначала проверяем data-атрибуты
                    const dataPrice = priceElement.getAttribute('data-price');
                    if (dataPrice) {
                        const parsedPrice = parseFloat(dataPrice);
                        if (!isNaN(parsedPrice) && parsedPrice > 0) {
                            return parsedPrice;
                        }
                    }
                    // Если data-атрибут не найден, парсим текст
                    const priceText = priceElement.textContent?.trim() || '';
                    if (priceText) {
                        // Парсим цену (убираем пробелы и заменяем запятую на точку)
                        const cleanPrice = priceText.replace(/\s/g, '').replace(',', '.');
                        const parsedPrice = parseFloat(cleanPrice);
                        if (!isNaN(parsedPrice) && parsedPrice > 0) {
                            return parsedPrice;
                        }
                    }
                }
            }
        }
        
        // Fallback: возвращаем 0 если цену не нашли
        return 0;
    }
    /**
     * Витягує правильний ID товару з пріоритетом product_price_id
     * @param {Object} productData - Дані товару
     * @returns {any} ID товару
     */
    extractProductId(productData) {
        if (!productData) {
            return '';
        }
        
        // Пріоритет 1: productPrice.price.productPriceId (camelCase - основне місце з API)
        const priceProductPriceId = productData.productPrice?.price?.productPriceId;
        if (priceProductPriceId !== null && priceProductPriceId !== undefined && priceProductPriceId !== '') {
            return priceProductPriceId;
        }
        
        // Пріоритет 2: productPrice.priceOld.productPriceId (camelCase - якщо є знижка)
        const priceOldProductPriceId = productData.productPrice?.priceOld?.productPriceId;
        if (priceOldProductPriceId !== null && priceOldProductPriceId !== undefined && priceOldProductPriceId !== '') {
            return priceOldProductPriceId;
        }
        
        // Пріоритет 3: productPrice.price.product_price_id (snake_case fallback)
        const snakeCasePriceId = productData.productPrice?.price?.product_price_id;
        if (snakeCasePriceId !== null && snakeCasePriceId !== undefined && snakeCasePriceId !== '') {
            return snakeCasePriceId;
        }
        
        // Пріоритет 4: productPrice.price_old.product_price_id (snake_case fallback)
        const snakeCasePriceOldId = productData.productPrice?.price_old?.product_price_id;
        if (snakeCasePriceOldId !== null && snakeCasePriceOldId !== undefined && snakeCasePriceOldId !== '') {
            return snakeCasePriceOldId;
        }
        
        // Пріоритет 5a: productPriceId (camelCase) на верхньому рівні об'єкта
        const topLevelProductPriceIdCamel = productData.productPriceId;
        if (topLevelProductPriceIdCamel !== null && topLevelProductPriceIdCamel !== undefined && topLevelProductPriceIdCamel !== '') {
            return topLevelProductPriceIdCamel;
        }
        
        // Пріоритет 5b: product_price_id (snake_case) на верхньому рівні об'єкта (fallback)
        const topLevelProductPriceId = productData.product_price_id;
        if (topLevelProductPriceId !== null && topLevelProductPriceId !== undefined && topLevelProductPriceId !== '') {
            return topLevelProductPriceId;
        }
        
        // Якщо product_price_id не знайдено - повертаємо порожній рядок (порожня колонка)
        return '';
    }
    /**
     * Нормалізує ідентифікатор до числового формату, якщо можливо (ідентично productViewTracker.js)
     * @param {any} id
     * @returns {number|string} Числовий ID або порожній рядок
     */
    normalizeId(id) {
        if (id === null || id === undefined) return '';
        const num = Number(id);
        if (!Number.isNaN(num) && Number.isFinite(num)) return num;
        return '' + id; // як фолбек рядок, щоб подія не впала
    }
    /**
     * Витягує бренд з заголовка товару (ідентично productViewTracker.js)
     * @param {string} title - Заголовок товару
     * @returns {string}
     */
    extractBrandFromTitle(title) {
        if (!title) return '';
        const parseBrandFromTitle = (title) => {
            const t = (title || '').trim();
            if (!t) return '';
            // Пріоритет 1: Шукаємо відомі бренди з модифікаторами (BauGlas FSX, RODECA, BAUGLAS)
            const knownBrands = ['BauGlas', 'RODECA', 'BAUGLAS'];
            for (const brand of knownBrands) {
                // Спочатку шукаємо бренд з можливими модифікаторами (FSX, Professional, тощо)
                const brandWithModifier = t.match(new RegExp(`\\b${brand}\\s+([A-Z]{2,}(?:\\s+[A-Za-z]+)*)\\b`, 'i'));
                if (brandWithModifier && brandWithModifier[0]) {
                    return brandWithModifier[0];
                }
                // Якщо не знайшли з модифікатором, шукаємо просто бренд
                const brandMatch = t.match(new RegExp(`\\b${brand}\\b`, 'i'));
                if (brandMatch && brandMatch[0]) {
                    return brandMatch[0];
                }
            }
            // Додатковий пошук: шукаємо "BauGlas FSX" як окремий випадок
            const bauGlasFSXMatch = t.match(/\bBauGlas\s+FSX\b/i);
            if (bauGlasFSXMatch && bauGlasFSXMatch[0]) {
                return bauGlasFSXMatch[0];
            }
            // Пріоритет 2: Шукаємо CamelCase (BauGlas, BauGlas FSX)
            const camelMatch = t.match(/\b[A-Z][a-z]+[A-Z][a-zA-Z]+(?:\s+[A-Z]+)*\b/);
            if (camelMatch && camelMatch[0]) {
                return camelMatch[0];
            }
            // Пріоритет 3: Шукаємо слова з великих літер (RODECA, BAUGLAS, FSX)
            const capsMatch = t.match(/\b[A-ZА-ЯЇІЄҐ]{3,}\b/u);
            if (capsMatch && capsMatch[0]) {
                return capsMatch[0];
            }
            // Пріоритет 4: Спробуємо знайти бренд до коми
            const commaIdx = t.indexOf(',');
            if (commaIdx > 0) {
                const beforeComma = t.slice(0, commaIdx).trim();
                if (beforeComma.length >= 2 && beforeComma.length <= 60) {
                    return beforeComma;
                }
            }
            // Пріоритет 5: Беремо перше слово з 3+ літер
            const firstWord = t.match(/\b[\p{L}]{3,}\b/u);
            if (firstWord && firstWord[0]) {
                return firstWord[0];
            }
            return '';
        };
        return parseBrandFromTitle(title);
    }
    /**
     * Знаходить назву товару по ID в DOM
     * @param {string|number} productId - ID товару
     * @returns {string}
     */
    findProductNameById(productId) {
        if (!productId) return '';
        // Шукаємо елементи з data-id або data-product-id
        const selectors = [
            `[data-id="${productId}"]`,
            `[data-product-id="${productId}"]`,
            `[data-item-id="${productId}"]`,
            `.product[data-id="${productId}"]`,
            `.product[data-product-id="${productId}"]`
        ];
        for (const selector of selectors) {
            const element = document.querySelector(selector);
            if (element) {
                const titleElement = element.querySelector('h1, h2, h3, h4, h5, h6, .title, .product-title, .product-name');
                if (titleElement) {
                    return titleElement.textContent?.trim() || '';
                }
            }
        }
        return '';
    }
    /**
     * Форматує товари з Vuex store
     * @param {Array} basketProducts - Товари з store
     * @returns {Array}
     */
    formatBasketItemsFromStore(basketProducts) {
        return basketProducts.map((item, index) => {
            // Різні варіанти структури даних - зберігаємо всю структуру
            const productData = {
                ...item, // Зберігаємо всі дані з item
                select_type: item.select_type,
                product: item.product,
                category: item.category || item.select_type?.category || item.product?.category || {name: '', title: ''}
            };
            const quantity = item.quantity || item.count || 1;
            // Використовуємо extractProductId для правильного витягування ID
            // Це забезпечить правильний пріоритет: productPrice.price.productPriceId > productPrice.priceOld.productPriceId > product_price_id > id
            const extractedId = this.extractProductId(productData);
            if (extractedId) {
                // Якщо знайшли ID через extractProductId, зберігаємо його
                productData.product_price_id = extractedId;
            }
            // Додатково: якщо немає назви, спробуємо отримати з select_type
            if (!productData.title && productData.select_type?.title) {
                productData.title = productData.select_type.title;
            }
            // Додатково: якщо немає ціни, спробуємо отримати з select_type
            if (!productData.price && productData.select_type?.price) {
                productData.price = productData.select_type.price;
            }
            return this.formatForAnalytics(productData, quantity);
        });
    }
    /**
     * Отримує товари з DOM
     * @returns {Array}
     */
    getBasketItemsFromDOM() {
        const items = [];
        // Шукаємо товари в різних місцях
        const productSelectors = [
            '.ordering .product', // Товары в заказе
            '.ordering .products .product',
            '.basket__products .product',
            '.order-product',
            '.checkout-product',
            '.product' // Загальний селектор
        ];
        for (const selector of productSelectors) {
            const productElements = document.querySelectorAll(selector);
            if (productElements.length > 0) {
                productElements.forEach((element, index) => {
                    const productData = this.extractProductDataFromElement(element);
                    if (productData) {
                        items.push(productData);
                    } else {
                    }
                });
                if (items.length > 0) {
                    break; // Якщо знайшли товари, зупиняємося
                }
            }
        }
        return items;
    }
    /**
     * Витягує дані товару з DOM елемента
     * @param {Element} element - Елемент товару
     * @returns {Object|null}
     */
    extractProductDataFromElement(element) {
        // Витягуємо назву товару - розширені селектори
        const titleSelectors = [
            '.product__desc-name h4', // Приоритет для basket-product компонента
            '.product-title-description', // Название в компоненте заказа
            'h1, h2, h3, h4, h5, h6',
            '.title, .product-title, .product-name',
            '.product__desc-name h5',
            '.product__name, .product-name',
            '[data-title], [data-name]',
            '.name, .item-name'
        ];
        let titleElement = null;
        let title = '';
        for (const selector of titleSelectors) {
            titleElement = element.querySelector(selector);
            if (titleElement) {
                title = titleElement.textContent?.trim() || titleElement.innerText?.trim() || '';
                if (title) {
                    // title found
                    break;
                }
            }
        }
        // Якщо назву не знайшли, спробуємо з data-атрибутів
        if (!title) {
            title = element.getAttribute('data-title') || 
                   element.getAttribute('data-name') || 
                   element.getAttribute('data-product-name') || '';
            if (title) {
            // title from data-attr
            }
        }
        if (!title) {
            // no title
            return null;
        }
        // Витягуємо артикул/ID - розширені селектори
        const articleSelectors = [
            '.product__desc-name-wrap h5', // Приоритет для basket-product компонента
            '[data-product-id]', // Приоритет: data-атрибуты
            '[data-id]',
            '[data-article]',
            '.article, .product-code, [class*="article"]',
            '.sku, .product-sku'
        ];
        let article = '';
        for (const selector of articleSelectors) {
            const articleElement = element.querySelector(selector);
            if (articleElement) {
                // Сначала проверяем data-атрибуты
                article = articleElement.getAttribute('data-product-id') ||
                         articleElement.getAttribute('data-id') ||
                         articleElement.getAttribute('data-article') ||
                         articleElement.textContent?.trim() || '';
                if (article) {
                    break;
                }
            }
        }
        // Якщо артикул не знайшли, спробуємо з самого елемента
        if (!article) {
            article = element.getAttribute('data-product-id') || 
                     element.getAttribute('data-id') || 
                     element.getAttribute('data-article') || '';
            }
        // Если ID все еще не найден, попробуем найти в родительских элементах
        if (!article) {
            let parentElement = element.parentElement;
            let level = 0;
            while (parentElement && level < 5 && !article) {
                article = parentElement.getAttribute('data-product-id') ||
                         parentElement.getAttribute('data-id') ||
                         parentElement.getAttribute('data-article') || '';
                if (article) {
                    break;
                }
                parentElement = parentElement.parentElement;
                level++;
            }
        }
        // Если ID все еще не найден, попробуем извлечь из Vue компонента
        if (!article && element.__vue__ && element.__vue__.$props && element.__vue__.$props.item) {
            const vueItem = element.__vue__.$props.item;
            article = vueItem.product_price_id || vueItem.id || vueItem.product_id || '';
        }
        // Витягуємо ціну за одиницю - ПРИОРИТЕТ для .product__price h5
        let price = 0;
        const priceSelectors = [
            '.product__price h5', // ПРИОРИТЕТ 1: цена за единицу товара в h5
            '.product__price', // ПРИОРИТЕТ 2: цена за единицу товара (fallback)
            '.product-price', // ПРИОРИТЕТ 3: цена товара
            '.price', // ПРИОРИТЕТ 4: общий селектор цены
            '[data-price]', // ПРИОРИТЕТ 5: data-атрибут
            '.cost, .amount' // ПРИОРИТЕТ 6: альтернативные селекторы
        ];
        
        for (const selector of priceSelectors) {
            const priceElement = element.querySelector(selector);
            if (priceElement) {
                // Сначала проверяем data-атрибуты
                const dataPrice = priceElement.getAttribute('data-price');
                if (dataPrice) {
                    const parsedPrice = parseFloat(dataPrice);
                    if (!isNaN(parsedPrice) && parsedPrice > 0) {
                        price = parsedPrice;
                        break;
                    }
                }
                // Если data-атрибут не найден, парсим текст
                const priceText = priceElement.textContent?.trim() || '';
                if (priceText) {
                    // Парсим цену (убираем пробелы и заменяем запятую на точку)
                    const cleanPrice = priceText.replace(/\s/g, '').replace(',', '.');
                    const parsedPrice = parseFloat(cleanPrice);
                    if (!isNaN(parsedPrice) && parsedPrice > 0) {
                        price = parsedPrice;
                        break;
                    }
                }
            }
        }
        // Витягуємо кількість - ПРИОРИТЕТ для product__amount-wrapper
        let quantity = 1;
        const quantitySelectors = [
            '.product__amount-wrapper input[type="number"]', // ПРИОРИТЕТ 1: basket-product компонент
            '.product__amount input[type="number"]', // ПРИОРИТЕТ 2: альтернативный селектор
            '.product__amount-wrapper .product__amount', // ПРИОРИТЕТ 3: span с количеством в wrapper
            '.product__amount', // ПРИОРИТЕТ 4: span с количеством
            '.product-amount', // Количество в компоненте заказа
            'input[type="number"]',
            '.quantity, [class*="quantity"]'
        ];
        
        for (const selector of quantitySelectors) {
            const quantityElement = element.querySelector(selector);
            if (quantityElement) {
                if (quantityElement.type === 'number') {
                    // Берем актуальное значение из input поля
                    quantity = parseInt(quantityElement.value) || parseInt(quantityElement.placeholder) || 1;
                } else {
                    const quantityText = quantityElement.textContent;
                    const quantityMatch = quantityText.match(/(\d+)/);
                    if (quantityMatch) {
                        quantity = parseInt(quantityMatch[1]);
                    }
                }
                if (quantity > 0) {
                    break;
            }
        }
        }
        // Витягуємо бренд
        let brand = '';
        const brandElement = element.querySelector('.brand, .manufacturer, [data-brand]');
        if (brandElement) {
            brand = brandElement.textContent?.trim() || brandElement.getAttribute('data-brand') || '';
        }
        // Формуємо об'єкт товару для форматування
        const productData = {
            title: title,
            id: article || '', // Не заменяем на название, оставляем пустым если ID не найден
            price: price, // Используем извлеченную цену
            productPrice: {
                price: {price: price},
                baseUnit: {isM2: false, title: 'шт'}
            },
            category: { name: '', title: '' },
            productBrand: { title: brand || this.extractBrandFromTitle(title) }
        };
        // Використовуємо уніфіковане форматування, передавая элемент для извлечения цены
        const result = this.formatForAnalytics(productData, quantity, element);
        return result;
    }
    /**
     * Відправляє подію begin_checkout в dataLayer
     * @param {Array} items - Масив товарів
     */
    sendBeginCheckoutEvent(items) {
        if (!window.dataLayer) {
            return;
        }
        // Отримуємо загальну вартість - ПРИОРИТЕТ для basket__total-wrapper-unit
        let totalValue = 0;
        // ПРИОРИТЕТ 1: Ищем в .basket__total-wrapper-unit (общая сумма корзины)
        const basketTotalElement = document.querySelector('.basket__total-wrapper-unit');
        if (basketTotalElement) {
            const totalPriceText = basketTotalElement.textContent?.trim() || '';
            // Парсимо ціну (прибираємо пробіли та замінюємо кому на крапку)
            const cleanPrice = totalPriceText.replace(/\s/g, '').replace(',', '.');
            const parsedPrice = parseFloat(cleanPrice);
            if (!isNaN(parsedPrice) && parsedPrice > 0) {
                totalValue = parsedPrice;
            }
        }
        // ПРИОРИТЕТ 2: Ищем в .total-price h3 (ordering сторінка)
        if (totalValue === 0) {
            const totalPriceElement = document.querySelector('.total-price h3');
            if (totalPriceElement) {
                const totalPriceText = totalPriceElement.textContent?.trim() || '';
                // Парсимо ціну (прибираємо пробіли та замінюємо кому на крапку)
                const cleanPrice = totalPriceText.replace(/\s/g, '').replace(',', '.');
                const parsedPrice = parseFloat(cleanPrice);
                if (!isNaN(parsedPrice) && parsedPrice > 0) {
                    totalValue = parsedPrice;
                }
            }
        }
        // Fallback: обчислюємо загальну вартість з товарів, якщо не знайшли в DOM
        if (totalValue === 0) {
            totalValue = items.reduce((sum, item) => {
                return sum + (parseFloat(item.price) * parseInt(item.quantity));
            }, 0);
        }
        // Очищуємо попередні дані ecommerce
        window.dataLayer.push({ecommerce: null});
        // Відправляємо подію з правильною структурою для GA4
        const eventData = {
            event: 'begin_checkout',
            ecommerce: {
                currency: items[0]?.currency || 'UAH', // Валюта на рівні ecommerce
                items: items.map(item => ({
                    item_id: item.item_id,
                    item_name: item.item_name,
                    item_brand: item.item_brand,
                    item_category: item.item_category,
                    price: parseFloat(item.price),
                    currency: item.currency || 'UAH',
                    quantity: parseInt(item.quantity)
                }))
            }
        };
        window.dataLayer.push(eventData);
    }
    // Видалено дубль методу trackBeginCheckout нижче; логіка об'єднана вище
    /**
     * Сохраняет цену за м² для использования в checkout (совместимость с productAddToCartMixin)
     * @param {number} price - Цена за м²
     */
    saveM2Price(price) {
        // Сохраняем цену в sessionStorage для использования в checkout
        try {
            if (typeof window !== 'undefined' && window.sessionStorage) {
                sessionStorage.setItem('ga_m2_price', price.toString());
            }
        } catch (e) {
            // Игнорируем ошибки sessionStorage
        }
    }

    /**
     * Очищає відстеження для нової сторінки
     */
    reset() {
        this.trackedCheckouts.clear();
        this.lastSentAt = 0;
    }
    /**
     * Зупиняє відстеження
     */
    destroy() {
        // Видаляємо слухачі подій
        document.removeEventListener('click', this.handleClick, true);
        document.removeEventListener('input', this.handleQuantityChange, true);
        document.removeEventListener('click', this.handleQuantityButtonClick, true);
        // Відключаємо DOM observer
        if (this.domObserver) {
            this.domObserver.disconnect();
            this.domObserver = null;
        }
        this.reset();
    }
}
// Експортуємо для використання
export default CheckoutTracker;